import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import TextField from '../text-field';
import StreetField from './street-field';
import SelectDropdownField from '../select-dropdown-field';

class Address extends Component {

  constructor(props) {
    super(props);

    this.state = {
      showAdditionalAddressFields: props.entity && props.entity.city ? true : false
    };

    this.STREET = 'street';
    this.APTSUITE = 'aptsuite';
    this.CITY = 'city';
    this.STATE = 'state';
    this.ZIP = 'zip';
    this.usStates = ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FL', 'GA', 'HI',
    'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO',
    'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI',
    'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'];

    this.stateDefaultValue = 'State';
  }

  validKey = (ev) => {
    let key = ev.key;

    if (key && key === 'Unidentified') {
      key = String.fromCharCode(ev.which ? ev.which : ev.keyCode);
    }

    const { name } = ev.target,
      ZERO = '0',
      NINE = '9',
      LOWERA = 'a',
      LOWERZ = 'z',
      UPPERA = 'A',
      UPPERZ = 'Z',
      HYPHEN = '-',
      APOSTROPHE = '\'',
      SPACE = ' ',
      ARROWLEFT = 'ArrowLeft',
      ARROWRIGHT = 'ArrowRight',
      DELETE = 'Delete',
      BACKSPACE = 'Backspace',
      TAB = 'Tab',
      validNum = (key >= ZERO && key <= NINE),
      validLowerCaseChar = (key >= LOWERA && key <= LOWERZ),
      validUpperCaseChar = (key >= UPPERA && key <= UPPERZ),
      validArrowKey = (key === ARROWLEFT || key === ARROWRIGHT),
      validZip = ( validNum || validArrowKey || key === DELETE || key === BACKSPACE || key === TAB),
      validCity = ( validArrowKey || key === SPACE || validLowerCaseChar || validUpperCaseChar ||
                    key === APOSTROPHE || key === DELETE || key === BACKSPACE || key === TAB || key === HYPHEN ),
      validAptSuite = validNum || validCity,
      validStreet = validNum || validCity;

    if ( (name === this.ZIP && !validZip) || (name === this.CITY && !validCity) || (name === this.STREET && !validStreet) || (name === this.APTSUITE && !validAptSuite) ) {
      ev.preventDefault();
    }
  }

  handleStreetAddressClick = () => {
    this.setState({ showAdditionalAddressFields: true });
  }

  handleStreetChange = (e) => {
    const { value } = e.target,
      elementValue = value ? value.trim() : value,
      { enterStreetAddress } = this.props.actions;
    enterStreetAddress(elementValue);
  }

  handleAptSuiteChange = (e) => {
    const { value } = e.target,
      elementValue = value ? value.trim() : value,
      { enterAptSuite } = this.props.actions;
    enterAptSuite(elementValue);
  }

  handleCityChange = (e) => {
    const { value } = e.target,
      { enterCity } = this.props.actions;
    enterCity(value);
  }

  handleStateChange = (e) => {
    const { value } = e.target,
      { selectState } = this.props.actions;
    selectState(value, this.stateDefaultValue);
  }

  handleZipChange = (e) => {
    const { value } = e.target,
      { enterZip } = this.props.actions;
    enterZip(value, 5);
  }

  // Smarty Streets event handler
  handleSuggestionSelected = (_, suggestion) => {
    const { enterStreetAddress,
            enterAptSuite,
            enterCity,
            selectState,
            enterZip } = this.props.actions;

    enterStreetAddress(suggestion.street);
    enterAptSuite('');
    enterCity(suggestion.city);
    selectState(suggestion.state, this.stateDefaultValue);
    enterZip(suggestion.zip, 5);
  }

  renderStreetInput = (props) => (
      <div>
        <input {...props}/>
        {props.helperText && <div className='section-helper-txt'>{props.helperText}</div>}
      </div>
  )

  renderAddrSec1 = () => {

    const streetErrMsg = this.props.errors.street;
    const { labelText, smartystreetsconfig, helperText, entity, errors, index } = this.props;

    const streetInputProps = {
      className: classNames('txt-field-input-medium', { 'txt-field-input--error': streetErrMsg }),
      id: `${this.STREET}_${index}`,
      name: `${this.STREET}_${index}`,
      placeholder: 'Street',
      onBlurCallback: this.handleStreetChange,
      onSuggestionSelected: this.handleSuggestionSelected,
      autoComplete: 'disabled',
      value: entity.street,
      onKeyDown: this.validKey,
      onFocusCallback: this.handleStreetAddressClick,
      helperText: helperText
    };

    return (

      <div className='input-helper'>
        <StreetField
          errorMsg={streetErrMsg}
          labelText={labelText}
          labelClassName='section-label'
          htmlFor={`${this.STREET}_${index}`}
          inputProps={streetInputProps}
          smartystreetsconfig={smartystreetsconfig}
          renderInputComponent= {this.renderStreetInput}
        />
        <TextField
          className='input-helper'
          id={`${this.APTSUITE}_${index}`}
          name={`${this.APTSUITE}_${index}`}
          labelText='Apt. / Suite #'
          labelClassName='section-label'
          htmlFor={`${this.APTSUITE}_${index}`}
          inputClassName='txt-field-input-small'
          placeholder='Optional'
          onChange={this.handleAptSuiteChange}
          onBlur={this.handleAptSuiteChange}
          onKeyDown={this.validKey}
          value={entity.aptsuite}
          errorMsg={errors.aptsuite}
          autoComplete='disabled'
        />
      </div>
    );
  }

  renderAddrSec2 = (addressType) => {

    const { entity, errors, index } = this.props;

    return (
      <div className='input-helper'>
        <TextField
          aria-required
          id={`${this.CITY}_${index}`}
          name={`${this.CITY}_${index}`}
          htmlFor={`${this.CITY}_${index}`}
          labelText='City'
          labelClassName='section-label'
          inputClassName='txt-field-input-medium'
          value={entity.city}
          errorMsg={errors.city}
          maxLength={23}
          placeholder='City'
          onChange={this.handleCityChange}
          onBlur={this.handleCityChange}
          onKeyDown={this.validKey}
          autoComplete='disabled'
        />

        <div className={classNames('input-helper', 'address-flex')}>
          <SelectDropdownField
            aria-required
            className='input-helper-state'
            id={`${this.STATE}_${index}`}
            name={`${this.STATE}_${index}`}
            htmlFor={`${this.STATE}_${index}`}
            labelText='State'
            labelClassName='section-label'
            selectClassName='select-dropdown-field-input-x-small'
            errorMsg={errors.state}
            listValues={this.usStates}
            defaultInitialValue={this.stateDefaultValue}
            value={entity.state}
            onChange={this.handleStateChange}
            onBlur={this.handleStateChange}
          />

          <TextField
            aria-required
            type='tel'
            className='input-helper-zip'
            id={`${this.ZIP}_${index}`}
            htmlFor={`${this.ZIP}_${index}`}
            name={`${this.ZIP}_${index}`}
            labelText='Zip'
            labelClassName='section-label'
            inputClassName='txt-field-input-small'
            value={entity.zip}
            errorMsg={errors.zip}
            maxLength={5}
            placeholder='Zip'
            onChange={this.handleZipChange}
            onBlur={this.handleZipChange}
            onKeyDown={this.validKey}
            autoComplete='disabled'
          />
        </div>
      </div>
    );
  }

  render() {
    return (
      <Fragment>
        {this.renderAddrSec1()}
        { this.state.showAdditionalAddressFields ?
          this.renderAddrSec2()
          : null
        }
      </Fragment>
    );
  }
}

Address.propTypes = {
  actions: PropTypes.object.isRequired,
  entity: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  labelText: PropTypes.string
};

Address.defaultProps = {
  labelText: 'Street Address',
  index: 1
};
export default Address;

